<template>
  <div>
    <div v-if="filterDepartment">
      <v-container class="mb-4">
        <v-row class="align-center justify-end">
          <v-btn
            color="info"
            text
            outlined
            :to="{
              name: 'Timetable',
              query: { code: codes },
            }"
            >Stundenpläne</v-btn
          >
          <v-btn
            color="info"
            class="ml-2"
            text
            outlined
            :to="{
              name: 'Meeting',
              query: { id: ids },
            }"
            >Treffen planen</v-btn
          >
        </v-row>
      </v-container>

      <v-card :loading="loading">
        <v-system-bar>Fachschaft {{ item.description }}</v-system-bar>

        <v-divider />
        <v-list subheader>
          <v-subheader v-if="itemsHead.length > 0">Vorsitz</v-subheader>
          <PersonItem
            v-for="teacher in itemsHead"
            :value="teacher"
            :key="teacher.id"
          >
          </PersonItem>
          <v-subheader v-if="itemsMembers.length > 0">Mitglieder</v-subheader>
          <PersonItem
            v-for="teacher in itemsMembers"
            :value="teacher"
            :key="teacher.id"
          ></PersonItem>
        </v-list>
      </v-card>
    </div>
    <v-alert text color="info" v-else>Bitte eine Fachschaft auswählen!</v-alert>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import PersonItem from "common/components/PersonItem.vue";
export default defineComponent({
  name: "TeacherDepartments",
  components: { PersonItem },
  props: ["filterDepartment", "filterDivision", "filterStvs", "id"],
  data() {
    return {
      item: {},
      loading: false,
      search: "",
      stvs: false,
    };
  },
  computed: {
    codes() {
      var members = this.itemsHead.concat(this.itemsMembers);
      return members.map((el) => el.code);
    },
    ids() {
      var members = this.itemsHead.concat(this.itemsMembers);
      return members.map((el) => el.id);
    },
    itemsHead() {
      return this.item.heads ? this.item.heads.filter(this.filter) : [];
    },
    itemsMembers() {
      return this.item.members ? this.item.members.filter(this.filter) : [];
    },
  },
  watch: {
    filterDepartment() {
      this.fetchData();
    },
  },
  methods: {
    filter(el) {
      return this.filterStvs || el.code.length == 3;
    },
    async fetchData() {
      if (this.filterDepartment) {
        this.loading = true;
        this.item = await this.apiGet({
          resource: "person/department",
          id: this.filterDepartment,
        });
        this.loading = false;
      } else {
        this.item = {};
      }
    },
  },
  created() {
    this.fetchData();
    if (this.id) {
      this.$emit("department", this.id);
    }
  },
});
</script>
